export default "__VITE_ASSET__BxQY0DER__"